import { ApolloProvider } from '@apollo/client';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { client } from './app/gql/client';
import './index.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#ffff',
    },
    secondary: {
      main: '#969CA3',
    },
  },
  typography: {
    fontFamily: "'Public Sans', sans-serif",
    button: {
      textTransform: 'none',
    },
    overline: {
      textTransform: 'none',
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter basename="/">
    <ApolloProvider client={client}>
      <React.StrictMode>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </React.StrictMode>
    </ApolloProvider>
  </BrowserRouter>
);
